import { isUndefined } from 'lodash-es';
import * as t from 'io-ts';
import { isNotNullable } from '@bayer-int/portletce-shared';

import type { MultiSelectDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';
import {
    getListOfMandatorySettingOptions,
    getMandatorySettingKeyBasedOnLabel,
} from './_settingsThatCanBeMandatory';

export interface MandatorySettingsSettingDefinition extends MultiSelectDefinition {
    key: 'MANDATORY_SETTINGS';
    type: 'MultiSelect';
}

const definition: MandatorySettingsSettingDefinition = {
    key: 'MANDATORY_SETTINGS',
    type: 'MultiSelect',
    label: 'Mandatory settings',
    value: [],
    options: [],
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.array(t.string));

export const codec = specSettingsInterface.input;

export const MandatorySettingsSettingDefinition = define({
    key: 'MANDATORY_SETTINGS',
    label: 'mandatorySettings',
    definition,
    fromSetting: settings => {
        const value = specSettingsInterface.extractValue(settings.mandatorySettings);

        if (isUndefined(value)) return undefined;

        return value
            .map(label => getMandatorySettingKeyBasedOnLabel(settings, label))
            .filter(isNotNullable);
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        !isUndefined(settings.mandatorySettings)
            ? {
                  ...definition,
                  ...specSettingsInterface.createDefinitionWithSettings(settings.mandatorySettings),
                  options: getListOfMandatorySettingOptions(settings),
              }
            : undefined,
});
